import { useIntl } from 'react-intl';

import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

import { useCampaignModuleContext } from '../context';

export const useIsMultiItemCampaignSupported = () => {
  const { entityType, merchantId, country, venues } = useCampaignModuleContext();
  const { isEmployee, user } = useUser();
  const intl = useIntl();

  const venueId = entityType === 'venue' ? venues[0]?.id : undefined;

  const eligibilityCriteria = {
    is_employee: isEmployee.toString(),
    user_id: user?.id || '',
    user_email: user?.email || '',
    user_country: user?.country || '',
    user_locale: intl.locale,
    merchant_id: merchantId,
    country,
    venue_id: venueId ?? '',
  };

  const { data: featureFlags } = useFeatureFlags(
    ['enable-multi-item-promotions-in-merchant-admin'],
    eligibilityCriteria,
    { enabled: !!user && !!venueId },
  );

  const isMultiItemCampaignSupported = featureFlags?.['enable-multi-item-promotions-in-merchant-admin'] === 'on';

  return { isMultiItemCampaignSupported };
};
